<template>
    <div class="heart_count" @click="likeItem">
        <div class="heart" :class="{'on': likeData.LikeStatus}"></div>
        <span>{{ returnCommas(likeData.likeCnt) }}</span>
    </div>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import {mapState} from "vuex";

export default {
    name: "LikeCompetitionDetailLayout",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        likeData: {}
    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        likeItem() {
            if(!util.isEmpty(this.UserInfo)){
                EventBus.$emit('like');
            }
        },
        returnCommas(x=0) {
            //return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return util.Number.numFormat(x);
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
